var _defs, _circle, _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRunaReport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 53.91 52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #feefe1;\n      }\n\n      .cls-2 {\n        fill: #fc7f11;\n      }\n\n      .cls-3 {\n        fill: #f8b180;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 26.95,
    cy: 26,
    r: 23.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M26.95,49.5c-12.96,0-23.5-10.54-23.5-23.5S13.99,2.5,26.95,2.5s23.5,10.54,23.5,23.5-10.54,23.5-23.5,23.5ZM26.95,4C14.82,4,4.95,13.87,4.95,26s9.87,22,22,22,22-9.87,22-22S39.08,4,26.95,4Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_628"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_505",
    className: "cls-2",
    d: "M29.51,21.62c-.61,0-1.1-.49-1.1-1.1h0v-6.23h-9.12c-.6,0-1.09.49-1.09,1.09h0v21.2c-.03.6.44,1.11,1.04,1.13,0,0,0,0,0,0h15.36c.6,0,1.09-.49,1.09-1.09v-15h-6.17ZM31.31,31.29c0,.3-.25.55-.55.55h-7.66c-.3,0-.55-.24-.55-.55,0,0,0,0,0,0v-.36c0-.3.25-.55.55-.55h7.66c.3,0,.55.25.55.55v.36ZM31.31,28.37c0,.3-.25.55-.55.55h-7.66c-.3,0-.55-.25-.55-.55h0v-.36c0-.3.24-.55.55-.55,0,0,0,0,0,0h7.66c.3,0,.55.25.55.55h0v.36ZM31.31,25.45c0,.3-.25.55-.55.55h-7.66c-.3,0-.55-.25-.55-.55h0v-.35c0-.3.24-.55.55-.55,0,0,0,0,0,0h7.66c.3,0,.55.25.55.55h0v.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_506",
    className: "cls-2",
    d: "M35.71,19.88v.28h-5.84v-5.87h.28c.29,0,.57.11.77.31l4.5,4.5c.19.21.29.49.28.78Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRunaReport);
export default __webpack_public_path__ + "static/media/Run a Report.1d9de8522f90592aeea25e36eb5b1b9b.svg";
export { ForwardRef as ReactComponent };